import useSWR from 'swr';
import WorthyApi from '../lib/api/worthyApi';
import _ from 'lodash';


export const useAppointment = (userId) => {
    const url = userId && WorthyApi.getAppointmentUrl(`/appointment/get_closest_appointment?user_id=${ userId }`);
    const { data, error } = useSWR(() => userId ? [ 'get', url ] : null, WorthyApi._httpReq);

    return {
        data: _.get(data, 'data.appointment'),
        isLoading: !error && !data,
        error
    };
}

